import React, { useEffect, useState, useContext, useRef, useCallback } from "react";
import Charge from "./Charge";
import { ButtonLoader } from "../../../utils/ButtonLoader";
import {UserContext } from "../../../../AppContextProvider";
import { useFetch } from "../../../api/FetchApiData";
import { useInfiniteScroll } from "../../../utils/InfiniteScroll";
import { BrowserView, isMobile } from "react-device-detect";
import searchBarIcon from '../../../icons/searchbar_gray.webp';
import { VitrineContext } from "../../VitrineContext";
if (isMobile)
    import('./charges_mob.css').then(() => {});
else
    import('./charges.css').then(() => {});

export default function Charges(props)
{
    const [HomeCharges,setHomeCharges] = useState([]);
    const [display,setDisplay] = useState({display:'none',text:'+'});
    const [hasMore,setHasMore] = useState(true);
    const [loading,setLoading] = useState(false);
    const [UserState,setUserState] = useContext(UserContext);
    const [charges,setCharges] = useState([]);
    const [search,setSearch] = useState('all');
    const [vitrines,setVitrines] = useContext(VitrineContext);
    const [page,setPage] = useState(1);
    const fetchData = useFetch();

    const AddChargeToHome = (charge)=>
    {
        HomeCharges.push(charge);
        setHomeCharges([...HomeCharges]);
    }

    const RemoveFromHomeCharges=(index)=>
    {
         HomeCharges.splice(parseInt(index),1);
         setHomeCharges([...HomeCharges]);
    }

    const ShowHomeCharges=()=>
    {
        if(HomeCharges.length===0)
        {
            return <p style={{fontSize:'x-small'}}>
                Veuillez sélectionner les élements que vous utilisez chez vous parmi les élements suivants. 
                Si vous ne trouvez pas ce qu'il vous faut, faite une recherche sur le champs au dessus. 
            </p>
        }
        else
        {
            return (
                <>
                {HomeCharges.map((charge, index)=>
                        <div key={index} className="charges-list">
                            <label>{charge.name+" ("+charge.quantity+")"}</label>
                            <input name={HomeCharges.indexOf(charge).toString()} onClick={e=>{RemoveFromHomeCharges(e.target.name)}} type="button" className="btnRemoveFromHome" value={'x'} />
                        </div>)
                }
                {
                    <input onClick={e=>{ApplyFiltres()}} type="button" value={'Demander un devis'} style={{border:'none',height:'30px',borderRadius:'5px',width:'80%', backgroundColor:'gold',display:'block',margin:'auto',marginTop:'5px',marginBottom:'5px'}} />
                }
                </>
                );
        }
    }

    const ApplyFiltres = ()=>
    {
        let power = 0;
        let capacite = 0;
        HomeCharges.forEach(char=>{
            power = char.power * char.quantity + power;
            if(char.night_use)
                capacite = (power)*char.duration*char.quantity + capacite;
        });
        const ad_filter = {capacite:capacite, puissance:power};
        console.log(ad_filter);
        setVitrines({articles:[],filters:{...vitrines.filters,advanced:JSON.stringify(ad_filter)},page:1});
    }

    useEffect(()=>{
        //console.log(HomeCharges);
        ApplyFiltres();
    },[HomeCharges])

    const FetchCharges= useCallback(async()=>{
        setLoading(true);
        fetchData.GetData(`pvcharge/?page=${page}&search=${search}`).then((result)=>{
            if(result.result)
            {
                setLoading(false);
                if(result.max<=charges.length)
                    setHasMore(false);
                else
                {
                    setCharges((prev)=>[...prev, ...result.charges]);
                    setPage(prev => prev+1);
                }
            }
        });
    },[page]);

    const LoadMoreRef = useInfiniteScroll(FetchCharges,hasMore);
    
    const HandleDisplay=()=>
    {
        if(display.display=='none')
        {setDisplay({display:'block',text:'-'});}
        else{setDisplay({display:'none',text:'+'});}
    }

    const NewCharge=()=>
    {
        if(UserState.is_staff)
            return(<Charge is_new={true} AddToHomeCharges={AddChargeToHome} />);
        else
            return;
    }

    useEffect(()=>{
        if(isMobile)
            setDisplay({display:'block',text:'+'});
    },[])

    let btn_colors = {bg:'goldenrod',font:'black'};
    if(isMobile)
        btn_colors = {bg:'goldenrod',font:'black'};

    return(
        <div id="Charges">
            <div id="FiltresTitle" style={{width:'100%',marginTop:'5px',marginBottom:'5px'}}>
                <div className="BtnDispFilters"><ButtonLoader text={display.text} onSubmit={e=>{HandleDisplay()}} style={{backGroundColor:btn_colors.bg,fontSize:'large',color:btn_colors.font}} loading={loading}/></div>
                <span>FILTRES AVANCES</span>
            </div>
            <div className="charges-block" style={{display:display.display,textAlign:'center'}}>
                <div className="charges-home">
                    { ShowHomeCharges() }
                </div>
                {NewCharge()}
                <div id="SearchCharge" style={{display:'inline-flex', flexDirection:'row',alignItems:'center',justifyItems:'center'}}>
                    <input onChange={e=>{setSearch(e.target.value);}} style={{fontSize:'x-small',width:'85%',margin:'0px',float:'inline-start',margin:'2px',height:'90%',textAlign:'center',border:'none'}} type="search" placeholder="Trouver un element"/>
                    <img onClick={e=>{setPage(1);setCharges([]);setHasMore(true);}} src={searchBarIcon} style={{height:'22px',margin:'2px',verticalAlign:'middle'}} />
                </div>
                <div  className="ChargesContainer" style={{width:'100%',textAlign:'center',margin:'auto',overflowY:'hidden'}}>
                    {
                        charges.map((charge,index)=>{
                            return <Charge key={index} is_new={false} AddToHomeCharges={AddChargeToHome} charge={charge} />
                        })
                    }
                    <div ref={LoadMoreRef} style={{height:'20px'}}/>
                </div>
            </div>
        </div>
    );
}